<template>
  <div id="menuItemModal" class="menu-builder__item-modal modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Menu item</h4>
          <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div v-if="source" class="modal-body">
          <div class="form-group">
            <div class="row">
              <div class="col-4">
                <label for="menuItemTitle">Title*</label>
              </div>
              <div class="col-8">
                <input
                  id="menuItemTitle"
                  v-model="entity.title"
                  type="text"
                  class="form-control"
                  data-validation="true"
                >
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-4">
                <label for="menuItemUrl">Url</label>
              </div>
              <div class="col-8">
                <input id="menuItemUrl" v-model="entity.url" type="text" class="form-control">
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-4">
                <label for="menuItemTooltip">Tooltip</label>
              </div>
              <div class="col-8">
                <input
                  id="menuItemTooltip"
                  v-model="entity.tooltip"
                  type="text"
                  class="form-control"
                >
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-4">
                <label for="menuItemTooltip">Open page</label>
              </div>
              <div class="col-8">
                <select id="menuItemTarget" v-model="entity.target" class="form-control">
                  <option value="_self">In current tab</option>
                  <option value="_blank">In new tab</option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-4">
                <label for="menuItemContentType">Entity Type</label>
              </div>
              <div class="col-8">
                <select id="menuItemContentType" v-model="entity.route" class="form-control">
                  <option :value="null">None</option>
                  <option
                    v-for="value in entityTypesList"
                    :key="value.name"
                    :value="value.value"
                  >
                    {{ value.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-4">
                <label for="menuItemPathAlias">Page Path Alias</label>
              </div>
              <div class="col-8">
                <input id="menuItemPathAlias" v-model="entity.path_alias" type="text" class="form-control">
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-4">
                <label for="menuItemPathAlias">Hidden</label>
              </div>
              <div class="col-1 d-flex align-items-center">
                <input id="menuItemPathAlias" v-model="entity.hidden" type="checkbox" class="form-control">
              </div>
            </div>
          </div>
          <div v-if="entity.route" class="form-group">
            <div class="row">
              <div class="col-4">
                <label>{{ routeName }}</label>
              </div>
              <div class="col-8">
                <vue-select
                  v-model="entity.parameters"
                  label="title"
                  :filterable="false"
                  :options="selectOptions"
                  @search="vueSelectOnSearch"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-4">
                <label>Image</label>
              </div>
              <div class="col-8">
                <image-uploader
                  :uploaded-img-url="entity.image ? entity.image.public_url : ''"
                  :removable="true"
                  @changeFile="imageChange"
                  @returnedOldFile="imageReturnedOld"
                  @existingFileRemoved="imageRemove"
                />
              </div>
            </div>
          </div>

          <div class="menu-builder__item-modal-error" style="color: red">{{ errorMessage }}</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary save-btn" @click="saveChanges">
            Save changes
            <span class="btn-loader" style="display: none;" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import VueSelect from 'vue-select';

export default {
  name: 'ModalMenuItem',

  components: {
    'vue-select': VueSelect,
  },

  data() {
    return {
      source: null,
      entity: {
        id: null,
        order: null,
        parent_id: null,
        title: null,
        url: '',
        tooltip: null,
        target: '_self',
        route: null,
        routeName: null,
        hidden: false,
        image: null,
        parameters: null,
        path_alias: null,
      },
      spot: null,
      action: 'new',
      selectOptions: [],
      errorMessage: '',
    };
  },

  computed: {
    routeName() {
      if (!this.entityTypesList.length) return null;
      return _.find(this.entityTypesList, e => e.value === this.entity.route).name;
    },
    entityTypesList() {
      const { list } = this.$store.state.contentTypes;
      if (list.length === 0) return [];
      const collection = Object.keys(list).map(e => ({
        name: e,
        value: list[e].route.item,
      }));
      return collection;
    },
    imageIsChanged() {
      if (!this.source.image) {
        return !!this.entity.image;
      }
      if (_.isObject(this.entity.image) && this.entity.image.id === this.source.image.id) {
        return false;
      }
      return true;
    },
  },

  watch: {
    'entity.route': function () {
      this.selectOptions = [];
      if (!this.source) return;
      if (this.entity.route === this.source.route) {
        this.entity.parameters = {
          id: this.source.parameters.id,
          title: this.source.parameters._title || this.source.parameters.text || this.source.parameters.title,
        };
      } else {
        this.entity.parameters = null;
      }
    },
  },

  mounted() {
    $(this.$el).find('input[data-validation="true"]').change(function () {
      $(this).parents('.form-group').removeClass('error');
    });

    this.$root.$on('menuItemSetParams', (content, action) => {
      this.source = content;
      this.entity.id = content.id;
      this.entity.parent_id = content.parent_id;
      this.entity.order = content.order;
      this.entity.title = content.title;
      this.entity.url = content.url || '';
      this.entity.tooltip = content.tooltip;
      this.entity.target = content.target ? content.target : '_self';
      this.entity.image = content.image;
      this.entity.path_alias = content.path_alias ? content.path_alias.path_alias : '';
      this.entity.hidden = !!content.hidden;
      if (content.route) {
        this.entity.route = content.route;
      }
      if (content.parameters) {
        this.entity.parameters = {
          id: content.parameters.id,
          title: content.parameters._title || content.parameters.text || content.parameters.title,
        };
      }

      this.spot = content.spot;
      this.action = action;

      $(this.$el).modal('show');
    });

    $(this.$el).on('hidden.bs.modal', () => {
      this.source = null;

      this.entity.id = null;
      this.entity.parent_id = null;
      this.entity.order = null;
      this.entity.title = null;
      this.entity.url = '';
      this.entity.tooltip = null;
      this.entity.route = null;
      this.entity.parameters = null;
      this.entity.image = null;
      this.entity.target = '_self';
      this.entity.path_alias = null;
      this.entity.hidden = false;

      this.spot = null;

      this.errorMessage = '';
    });
  },

  destroyed() {
    $('.modal-backdrop').remove();
    this.$root.$off('menuItemSetParams');
  },

  methods: {
    vueSelectOnSearch(search, loading) {
      loading(true);
      this.vueSelectSearch(loading, search, this);
    },
    vueSelectSearch: _.debounce((loading, search, vm) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}content-types/${vm.routeName}`, {
        params: {
          search_string: escape(search),
        },
      }).then((response) => {
        const newDataArr = [];
        _.forIn(response.data, (value, key) => {
          if (key !== 'meta') {
            newDataArr.push(value);
          }
        });
        context.selectOptions = newDataArr;
        loading(false);
      }).catch((error) => {
        console.error(error);
      });
    }, 350),
    imageChange(file) {
      this.entity.image = file;
    },
    imageReturnedOld() {
      this.entity.image = this.source.image;
    },
    imageRemove() {
      this.entity.image = null;
    },
    formIsValide() {
      if (!this.entity.title) {
        this.errorMessage = 'Field title is required';
        return false;
      }
      return true;
    },
    saveChanges() {
      if (!this.formIsValide()) return;
      if (this.action === 'new') {
        this.saveNew();
      } else if (this.action === 'edit') {
        this.saveExisting();
      }
    },
    preSave() {
      this.errorMessage = '';
      $(this.$el).find('.btn-loader').show();
      const postFormData = new FormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('target', this.entity.target);
      postFormData.append('order', this.entity.order);
      postFormData.append('tooltip', this.entity.tooltip ? this.entity.tooltip : '');
      postFormData.append('url', this.entity.url);
      postFormData.append('path_alias', this.entity.path_alias);
      postFormData.append('hidden', this.entity.hidden);
      if (this.entity.parent_id) postFormData.append('parent_id', this.entity.parent_id);
      if (this.entity.route) postFormData.append('route', this.entity.route);
      if (this.entity.parameters) {
        postFormData.append('parameters', JSON.stringify({
          id: this.entity.parameters.id,
          _title: this.entity.parameters.title,
        }));
      }
      return postFormData;
    },
    updateImageRequest() {
      const { prefix } = this.$config.app_api;
      const postFormData = new FormData();
      postFormData.append('image', this.entity.image);
      return this.$apiHttp.post(
        `${prefix}menu/${this.source.menu_id}/menu-items/${this.entity.id}/image`,
        postFormData,
      );
    },
    deleteImageRequest() {
      const { prefix } = this.$config.app_api;
      return this.$apiHttp.delete(`${prefix}menu/${this.source.menu_id}/menu-items/${this.entity.id}/image`);
    },
    saveExistingRequest(postFormData) {
      const { prefix } = this.$config.app_api;
      return this.$apiHttp.post(
        `${prefix}menu/${this.source.menu_id}/menu-items/${this.entity.id}`,
        postFormData,
      );
    },
    successSaveExistingCallback(newContent, image) {
      this.$root.$emit('menuItemSaveExistingSuccess', newContent, image);
      $(this.$el).find('.btn-loader').hide();
      $(this.$el).modal('hide');
    },
    errorSaveExistingCallback() {
      $(this.$el).find('.btn-loader').hide();
      this.errorMessage = 'Changes did not saved. There are some problems with server.';
    },
    saveExisting() {
      const postFormData = this.preSave();
      if (!this.imageIsChanged) {
        this.saveExistingRequest(postFormData)
          .then((response) => {
            this.successSaveExistingCallback(response.data, this.entity.image);
          })
          .catch(() => {
            this.errorSaveExistingCallback();
          });
      } else if (this.entity.image) {
        axios.all([this.updateImageRequest(), this.saveExistingRequest(postFormData)])
          .then(axios.spread((image, entity) => {
            if (Math.round(image.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
              this.successSaveExistingCallback(entity.data, image.data);
            } else {
              this.errorSaveExistingCallback();
            }
          }));
      } else {
        axios.all([this.deleteImageRequest(), this.saveExistingRequest(postFormData)])
          .then(axios.spread((image, entity) => {
            if (Math.round(image.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
              this.successSaveExistingCallback(entity.data);
            } else {
              this.errorSaveExistingCallback();
            }
          }));
      }
    },
    saveNew() {
      const postFormData = this.preSave();
      if (this.entity.image) postFormData.append('image', this.entity.image);
      this.$apiHttp.post(
        `${this.$config.app_api.prefix}menu/${this.source.menu_id}/menu-items?with[]=image`,
        postFormData,
      ).then((response) => {
        this.$root.$emit('menuItemSaveNewSuccess', response.data, this.spot);
        $(this.$el).find('.btn-loader').hide();
        $(this.$el).modal('hide');
      }).catch((error) => {
        $(this.$el).find('.btn-loader').hide();
        this.errorMessage = 'Item did not created. There are some problems with server.';
        console.error(error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// MenuItem.vue?1a577f9c